import Loadable from 'react-loadable';
import { loading } from 'router';
import { Me, ThreeHexagons, AdProduct, DatabaseSetting } from '@icon-park/react';
import React from 'react';
import Icon from '@m-ui/icons';
import moment from 'moment';
import { IRouterItem } from '../../../component/SideMenu';
import { APP_ID_TYPE } from 'constants/constants';

export const marketMenu: IRouterItem[] = [
    {
        title: '推荐专区',
        key: '/market/recommend',
        path: '/market/recommend',
        showNewIcon: true,
        showGuide: true,
        filter: (userInfo) => !userInfo.dmpRecommendAreaEnable, // 无推荐专区 2.0 的用户，展示推荐专区 1.0 的入口
    },
    {
        title: '行业通用人群',
        key: '/market/industry_population',
        path: '/market/industry_population',
    },
    {
        title: '新线人群',
        key: '/market/newline_population',
        path: '/market/newline_population',
    },
    {
        title: '小店专区',
        key: '/market/special',
        path: '/market/special',
    },
    {
        title: '节日专区',
        key: '/market/holiday',
        path: '/market/holiday',
    },
    {
        title: '818大促专区',
        key: '/market/section818',
        path: '/market/section818',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2024-8-21 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '情人节专区',
        key: '/market/section214',
        path: '/market/section214',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2023-2-15 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '中秋节专区',
        key: '/market/mid-autumn',
        path: '/market/mid-autumn',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2022-9-12 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '国庆节专区',
        key: '/market/notional-day',
        path: '/market/notional-day',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2022-10-11 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '618大促',
        key: '/market/section618',
        path: '/market/section618',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2024-06-19 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '520宠爱日专区',
        key: '/market/section520',
        path: '/market/section520',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2022-05-23 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '疫情专区',
        key: '/market/covid19',
        path: '/market/covid19',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2022-07-06 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '双11购物节专区',
        key: '/market/double-eleven',
        path: '/market/double-eleven',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2022-11-12 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '双12专区',
        key: '/market/double-twelve',
        path: '/market/double-twelve',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2022-12-20 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '年货节专区',
        key: '/market/new-years-goods',
        path: '/market/new-years-goods',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2023-01-02 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '38节专区',
        key: '/market/goddess',
        path: '/market/goddess',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2024-3-9 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '双11购物节专区',
        key: '/market/double-eleven',
        path: '/market/double-eleven',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2024-11-12 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '春节专区',
        key: '/market/spring-festival',
        path: '/market/spring-festival',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2024-02-18 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '年货节专区',
        key: '/market/new-years-goods',
        path: '/market/new-years-goods',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2024-01-29 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '礼赠专区',
        key: '/market/gift',
        path: '/market/gift',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2024-05-20 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '换季变温专区',
        key: '/market/season',
        path: '/market/season',
    },
    {
        title: '双12购物节专区',
        key: '/market/double-twelve',
        path: '/market/double-twelve',
        showNewIcon: true,
        filter: () => moment().isBefore(moment('2023-12-13 00:00:00', 'YYYY-MM-DD HH:mm:ss')),
    },
    {
        title: '游戏专区',
        key: '/market/game',
        path: '/market/game',
    },
];

export const menuConfig: IRouterItem[] = [
    {
        title: '我的人群',
        key: '/market/my_population',
        path: '/market/my_population',
        icon: <Icon component={() => <Me theme="outline" size="16" fill="#333" />} />,
    },
    {
        title: '主题专区',
        key: 'theme',
        path: '/market',
        icon: <Icon component={() => <AdProduct theme="outline" size="16" fill="#333" />} />,
        children: marketMenu,
        showChildren: true,
    },
    // {
    //     title: '三方精选',
    //     key: '/market/feature',
    //     path: '/market/feature',
    //     filter: (userInfo) => !userInfo.isKa,
    //     icon: <Icon component={() => <ThreeHexagons theme="outline" size="16" fill="#333" />} />,
    // },
    {
        title: '数据源',
        key: '/market/props_data',
        path: '/market/props_data',
        filter: (userInfo) =>
            userInfo?.appId === APP_ID_TYPE.DSP_APP || userInfo?.appId === APP_ID_TYPE.AD_ESP, // 支持DMP效果/磁力金牛账号的全量用户拥有该权限
        icon: <Icon component={() => <DatabaseSetting theme="outline" size="16" fill="#333" />} />,
        showChildren: false,
        children: [
            {
                title: '新建数据源',
                key: '/market/props_data_operation',
                path: '/market/props_data_operation',
            },
        ],
    },
];

export const MarketRoutes = [
    {
        path: '/market/industry_population',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'ecom' */ 'modules/Market/IndustryPopulation'),
            loading,
        }),
    },
    {
        path: '/market/common_population',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'CommonPopulation' */ 'modules/Market/CommonPopulation'
                ),
            loading,
        }),
    },
    {
        path: '/market/special',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'EcomSection' */ 'modules/Market/ShopSection'),
            loading,
        }),
    },
    {
        path: '/market/holiday',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'EcomSection' */ 'modules/Market/HolidaySection'),
            loading,
        }),
    },
    {
        path: '/market/olympic',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'olympicSection' */ 'modules/Market/OlympicSection'),
            loading,
        }),
    },
    {
        path: '/market/double-eleven',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'DoubleElevenSection' */ 'modules/Market/DoubleElevenSection'
                ),
            loading,
        }),
    },
    {
        path: '/market/double-twelve',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'DoubleTwelveSection' */ 'modules/Market/DoubleTwelveSection'
                ),
            loading,
        }),
    },
    {
        path: '/market/recommend',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'RecommendSection' */ 'modules/Market/RecommendSection'
                ),
            loading,
        }),
    },
    {
        path: '/market/feature',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'TripartiteFeatured' */ 'modules/Market/TripartiteFeatured'
                ),
            loading,
        }),
    },
    {
        path: '/market/my_population',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'MyPopulation' */ 'modules/Market/MyPopulation'),
            loading,
        }),
    },
    // 兼容旧路径
    {
        path: '/population',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'MyPopulation' */ 'modules/Market/MyPopulation'),
            loading,
        }),
    },
    // 兼容旧路径
    {
        path: '/population/manage',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'MyPopulation' */ 'modules/Market/MyPopulation'),
            loading,
        }),
    },
    {
        path: '/market/props_data',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'PropsDataSource' */ 'modules/Market/PropsDataSource'),
            loading,
        }),
    },
    {
        path: '/market/props_data_operation',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'PropsDataSource' */ 'modules/Market/PropsDataSource/Operation'
                ),
            loading,
        }),
    },
    {
        path: '/market/new-years-goods',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'NewYearsGoods' */ 'modules/Market/NewYearsGoods'),
            loading,
        }),
    },
    {
        path: '/market/goddess',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'goddess' */ 'modules/Market/Goddess'),
            loading,
        }),
    },
    {
        path: '/market/covid19',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'covid19' */ 'modules/Market/Covid19'),
            loading,
        }),
    },
    {
        path: '/market/section520',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'section520' */ 'modules/Market/520Section'),
            loading,
        }),
    },
    {
        path: '/market/section618',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'section616' */ 'modules/Market/616Section'),
            loading,
        }),
    },
    {
        path: '/market/mid-autumn',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'MidAutumn' */ 'modules/Market/MidAutumn'),
            loading,
        }),
    },
    {
        path: '/market/notional-day',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'notionalDay' */ 'modules/Market/NotionalDay'),
            loading,
        }),
    },
    {
        path: '/market/section214',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'section214' */ 'modules/Market/214Section'),
            loading,
        }),
    },
    {
        path: '/market/newline_population',
        component: Loadable({
            loader: () =>
                import(
                    /* webpackChunkName: 'newline-population' */ 'modules/Market/NewlineSection'
                ),
            loading,
        }),
    },
    {
        path: '/market/game',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'game-population' */ 'modules/Market/GameSection'),
            loading,
        }),
    },
    {
        path: '/market/gift',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'gift-population' */ 'modules/Market/GiftSection'),
            loading,
        }),
    },
    {
        path: '/market/section818',
        component: Loadable({
            loader: () => import(/* webpackChunkName: 'section818' */ 'modules/Market/818Section'),
            loading,
        }),
    },
    {
        path: '/market/season',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'season-population' */ 'modules/Market/SeasonSection'),
            loading,
        }),
    },
    {
        path: '/market/spring-festival',
        component: Loadable({
            loader: () =>
                import(/* webpackChunkName: 'spring-population' */ 'modules/Market/SpringFestival'),
            loading,
        }),
    },
];
